module.exports = __webpack_public_path__ + "img/CS-Lite-Vol_Overview-Spare_3.5a1008b6.jpg";